import { memo, useMemo } from 'react'
import { Chip } from 'src/components/shared/Chip'
import { colors } from 'src/theme'
import tw from 'twin.macro'
import { subcontractorRequestStatusTitles } from 'src/constants/subcontractorRequests/constants'
import { SubcontractorRequestStatus } from 'src/constants/subcontractorRequests/enum'

interface Props {
  status: SubcontractorRequestStatus
}

const subcontractorStatusMap = {
  [SubcontractorRequestStatus.Active]: {
    color: colors.COLORS_GREEN_500,
    text: subcontractorRequestStatusTitles[SubcontractorRequestStatus.Active],
    bgStyle: tw`bg-[rgba(230, 249, 233, 1)]`,
  },
  [SubcontractorRequestStatus.Inactive]: {
    color: colors.COLORS_RED_500,
    text: subcontractorRequestStatusTitles[SubcontractorRequestStatus.Inactive],
    bgStyle: tw`bg-[rgba(255, 232, 238, 1)]`,
  },
  [SubcontractorRequestStatus.Rejected]: {
    color: colors.COLORS_RED_500,
    text: subcontractorRequestStatusTitles[SubcontractorRequestStatus.Rejected],
    bgStyle: tw`bg-[rgba(255, 232, 238, 1)]`,
  },
  [SubcontractorRequestStatus.PendingCustomerReview]: {
    color: colors.COLORS_ORANGE_500,
    text: subcontractorRequestStatusTitles[SubcontractorRequestStatus.PendingCustomerReview],
    bgStyle: tw`bg-[rgba(255, 238, 214, 1)]`,
  },
}

const getSubcontractorStatusParams = (status: SubcontractorRequestStatus) =>
  subcontractorStatusMap[status] || {
    color: colors.SHADES_GREY_500,
    text: status,
    bgStyle: tw`bg-[rgba(218, 217, 224, 1)]`,
  }

const SubcontractorStatusChipComponent = ({ status }: Props) => {
  const params = useMemo(() => getSubcontractorStatusParams(status), [status])

  return (
    <div css={tw`flex items-center`}>
      <div css={tw`py-1 rounded-[10px]`}>
        <Chip className={params.bgStyle} textColor={params.color} text={params.text} />
      </div>
    </div>
  )
}

export const SubcontractorStatusChip = memo(SubcontractorStatusChipComponent)
